var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"appMain",staticClass:"contents wrap"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }